
import Vue from 'vue'
import Location from './location'

export default Vue.extend({
    props: {
        location: {
            type: Object as () => Location
        }
    }
})
